import {
  useQuery,
  ExtractFnReturnType,
  QueryConfigType,
  UseQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApisAdminOperatorsOperatorsNewResponseType } from "~/domains";

const request =
  async (): Promise<ApisAdminOperatorsOperatorsNewResponseType> => {
    const response =
      await new ApiClient().get<ApisAdminOperatorsOperatorsNewResponseType>(
        "/api/admin_operators/operators/new",
      );
    return response.data;
  };

type QueryFnType = typeof request;

type PropsType = {
  config?: QueryConfigType<QueryFnType>;
};

export const useApisAdminOperatorsOperatorsNew = ({
  config = {},
}: PropsType): UseQueryResult<ApisAdminOperatorsOperatorsNewResponseType> => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ["ApisAdminOperatorsOperatorsNew"],
    queryFn: () => request(),
  });
};
